import { formatDate } from "../../../lib/time";
import { GetEmployeeDetailsResponseType } from "../../../types";
import { underscoreToCapitalizeString } from "../../../utils/utils";
import InfoItem from "../../common/InfoItem";
import EditButtonEmployee from "./EditButtonEmployee";

type Props = {
  data?: GetEmployeeDetailsResponseType;
};

export default function OfficialInfo({ data }: Props) {
  return (
    <ul>
      <InfoItem title="Name">
        {data?.data?.employee?.member?.profile?.name}
      </InfoItem>
      <InfoItem title="Email">
        {data?.data?.employee?.member?.profile?.email}
      </InfoItem>
      <InfoItem title="Department">
        {data?.data?.employee?.role?.department?.name}
      </InfoItem>
      <InfoItem title="Designation">
        {data?.data?.employee?.role?.name}
      </InfoItem>
      <InfoItem title="Manager">
        {data?.data?.employee?.manager?.member?.profile?.name}
      </InfoItem>
      <InfoItem title="Date of joining">
        {data?.data?.employee?.join_date
          ? formatDate(data?.data?.employee?.join_date)
          : undefined}
      </InfoItem>
      <InfoItem title="Employee Type">
        {data?.data?.employee?.employee_type
          ? underscoreToCapitalizeString(data?.data?.employee?.employee_type)
          : undefined}
      </InfoItem>
      <InfoItem title="Employee ID">
        {data?.data?.employee?.employee_id}
      </InfoItem>
      {/* GS-4 start */}
      <InfoItem title="RFID">{data?.data?.employee?.rfid || "N/A"}</InfoItem>
      {/* GS-4 end */}
      <InfoItem title="Grade">{data?.data?.employee?.grade}</InfoItem>
      <InfoItem title="Business Unit">
        {data?.data?.expense_unit_details?.name}
      </InfoItem>
      <InfoItem title="Work Station">
        {data?.data?.work_station_details?.name}
      </InfoItem>
      {data?.data?.employee?.status !== "invited" && (
        <EditButtonEmployee type="Official" />
      )}
    </ul>
  );
}
